<div class="frame-in">
  <div class="items" [ngStyle]="itemsStyle" [ngClass]="{'hidden': loading}">
    <div class="country new-zealand" [ngClass]="{'hover': zones[0].hover}">
    </div>
    <div class="poi" (mouseenter)="mouseEnter(0)" (mouseleave)="mouseLeave(0)"
             style="bottom: 112px; right: 80px;" [ngClass]="{'hover': zones[0].hover,
             'active': zones[0].active
             }"
      (click)="poiClick(1)">
      <span>1</span>
    </div>
    <div class="country philippines" [ngClass]="{'hover': zones[1].hover}"></div>

    <div class="country thailand" [ngClass]="{'hover': zones[2].hover}"></div>
    <div class="country malaysia" [ngClass]="{'hover': zones[3].hover}"></div>
    <div class="poi" (mouseenter)="mouseEnter(3)" (mouseleave)="mouseLeave(3)"
      style="bottom: 470px; left: 225px;"
             [ngClass]="{
             'hover': zones[3].hover,
             'lock': zones[3].locked,
             'active': zones[3].active && quizLevel !== 1
             }"
      (click)="poiClick(4)">
      @if (!zones[3].locked) {
        <span>4</span>
      }
    </div>
    <div class="country indonesia" [ngClass]="{'hover': zones[2].hover}"></div>
    <div class="poi" (mouseenter)="mouseEnter(2)"
      (mouseleave)="mouseLeave(2)" style="bottom: 344px; left: 226px;"
             [ngClass]="{
                'hover': zones[2].hover,
                'lock': zones[2].locked,
                'active': zones[2].active
                }"
      (click)="poiClick(3)">
      @if (!zones[2].locked) {
        <span>3</span>
      }
    </div>
    <div class="country australia" [ngClass]="{'hover': zones[5].hover}"></div>
    <div class="poi" (mouseenter)="mouseEnter(5)"
             (mouseleave)="mouseLeave(5)" style="bottom: 122px; right: 336px;" [ngClass]="{'hover': zones[5].hover,
             'lock': zones[5].locked,
             'active': zones[5].active
             }"
      (click)="poiClick(2)">
      @if (!zones[5].locked) {
        <span>2</span>
      }
    </div>

    @if (!quizLevel || quizLevel < 1) {
      <div class="quiz-activity"></div>
    }
    @if (quizLevel >= 1) {
      <div class="quiz-activity active" [ngClass]="{'current': quizLevel === 1 && tick2Quiz}" [routerLink]="['/game/quiz-activity/1-1']"></div>
    }

    <svg class="road">
      <path id="svg_5" d="m742.5,466.1375c-20,21 -94,27 -94,27c-111,-17 -111,-69 -164.5,-70.1375c-107.5,17.1375 -70.5,51.1375 -139.5,56.1375c-28,10 -58,-15 -58.5,-15.1375c-14.5,-10.8625 -13.5,-26.8625 -13.5,-26.8625c20,-58 16,-100 16,-100c-12,-26 -25,-34 -27,-33c-11,-8 -31,4 -69,-11c-29,-8 -34,-34 -38,-44c-4,-10 -11,-48.275 -7.5,-64.1375c3.5,-15.8625 23.5,-21.8625 23.5,-43.8625c-14,-34 -30,-57 -44.5,-60.1375c-23.5,-3.8625 -33.5,4.1375 -33.5,4.1375c-20,6 -11,21 -41,28c-23,3 -36,-8 -36,-8c-16,-15 -15,-30 -15.5,-30.1375c0.5,0.1375 4.5,-30.8625 9.5,-33.8625c13,-20 33,-20 33,-20c0,0 21,-1 42,8c14,4 19,3 27,-5c7,-5 12,-24 12,-24" fill-opacity="null" stroke-opacity="null" stroke="#000" fill="none" />
    </svg>

    <!-- <div class="plane" [ngClass]="{'to-1': plane.position == 1, 'to-2': plane.position == 2, 'to-3': plane.position == 3, 'to-4': plane.position == 4}"></div> -->

    <audio id="introductionAudio" (ended)="playBgAudio()">
      <source src="assets/sounds/country.wav" type="audio/wav">
    </audio>
    <audio id="bgAudio" (ended)="playIntroductionAudio()">
      <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
    </audio>

    <img class="frame-bg" src="assets/images/zones/1/bg.jpg">
  </div>
</div>

<img class="frame-title" src="assets/images/zones/1/title.png">
<div class="footer">
  <ul class="zone-menu">
    <li>
      <a class="menu-item" [routerLink]="[ '/game/zone1' ]" routerLinkActive="active">1</a>
    </li>
    <li>
      @if (!haveAccess('1-2')) {
        <span class="lock"></span>
      }
      @if (haveAccess('1-2')) {
        <a class="menu-item" [routerLink]="[ '/game/zone2' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('1-3')) {
        <span class="lock"></span>
      }
      @if (haveAccess('1-3')) {
        <a class="menu-item" [routerLink]="[ '/game/zone3' ]" routerLinkActive="active">3</a>
      }
    </li>
    <li>
      @if (!haveAccess('1-4')) {
        <span class="lock"></span>
      }
      @if (haveAccess('1-4')) {
        <a class="menu-item" [routerLink]="[ '/game/zone4' ]" routerLinkActive="active">4</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/1/footer.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
